<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-8 offset-md-2">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">UUSS Capitanías de Puerto</h4>        
                    <hr>
                    <p> Administracion de UUSS de las capitanias de Puerto </p>                    
                </div>
            </div>            

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-high-traffic" data-toggle="tab" href="#nav-high" role="tab" aria-controls="nav-home" aria-selected="true"><font-awesome-icon icon="plus" /> Alta UUSS</a>
                    <a class="nav-item nav-link" id="nav-edit-traffic" data-toggle="tab" href="#nav-edit" role="tab" aria-controls="nav-profile" aria-selected="false"><font-awesome-icon icon="edit" /> Edición UUSS</a>
                    <a class="nav-item nav-link" id="nav-low-traffic" data-toggle="tab" href="#nav-low" role="tab" aria-controls="nav-profile" aria-selected="false"><font-awesome-icon icon="arrow-down" /> Baja UUSS</a>
                </div>
            </nav>

            <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="nav-high" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6 align="center">Registro de UUSS de las Capitanias de Puerto</h6>
                    <hr>                    
                    
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-4" v-if="cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'">
                            <label for="nombre_embarcacion">Capitania <span class="required-text">*</span></label>  
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div v-else class="alert alert-success col-12 col-md-4 offset-md-4" align="center">
                            {{ cDtsUser.name_port }}
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="name_uuss">Nombre UUSS <span class="required-text">*</span></label>
                            <input type="text" class="form-control" id="name_uuss" placeholder="NAVE TIBURON"  autocomplete="off" v-model="uuss_new.name">
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="type_uuss">Tipo UUSS <span class="required-text">*</span></label>
                            <select name="type_uuss" class="form-control" id="type_uuss" v-model="uuss_new.type_uuss">
                                <option v-for="usup in uuss" :value="usup.id" :key="usup.id">{{usup.detail}}</option>
                            </select>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="operability_uuss">Operabilidad <span class="required-text">*</span></label>
                            <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="uuss_new.operability">
                                <option v-for="op in operabilitys" :value="op.id" :key="op.id">{{op.detail}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="code_uuss">Codigo / Matricula UUSS <span class="required-text">*</span></label>
                            <input type="text" class="form-control" id="code_uuss" placeholder="CP-0099"  autocomplete="off" v-model="uuss_new.code">
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="trb_uuss">TRB UUSS <span class="required-text">*</span></label>
                            <input type="number" class="form-control" id="trb_uuss" placeholder="0"  autocomplete="off" v-model="uuss_new.trb">
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="trn_uuss">TRN UUSS <span class="required-text">*</span></label>
                            <input type="number" class="form-control" id="trn_uuss" placeholder="0"  autocomplete="off" v-model="uuss_new.trn">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="description_uuss">Descripcion UUSS <span class="required-text">*</span></label>
                            <textarea class="form-control" name="description_uuss" id="description_uuss" cols="100" rows="4" v-model="uuss_new.description"></textarea>
                        </div>
                    </div>
                    
                    <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mRegisterInitUUSS">
                            <font-awesome-icon icon="save" size="3x" />
                    </button>

                </div>
                <!-- end first (high uuss) tab -->
                
                <div class="tab-pane fade"  id="nav-edit" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6 align="center">Busqueda y Edicion de UUSS</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="uuss_edit.id > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ uuss_edit.captain }}</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseEdit">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Nombre</b></td>
                                    <td><b>Tipo</b></td>
                                    <td><b>Operabilidad</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control" name="name_ship_edit" v-model="uuss_edit.name"></td>
                                    <td>
                                        <select name="type_uuss" class="form-control" id="type_uuss" v-model="uuss_edit.type_uuss">
                                            <option v-for="usup in uuss" :value="usup.id" :key="usup.id" :selected="usup.id === uuss_edit.type_uuss ? true : false">{{usup.detail}}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="uuss_edit.operability">
                                            <option v-for="oper in operabilitys" :value="oper.id" :key="oper.id" :selected="oper.id === uuss_edit.operability ? true : false">{{oper.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Codigo</b></td>
                                    <td><b>TRB</b></td> 
                                    <td><b>TRN</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control" name="code_ship_edit" v-model="uuss_edit.code"></td>
                                    <td><input type="numeric" class="form-control" name="trb_ship_edit" v-model="uuss_edit.trb"></td> 
                                    <td><input type="text" class="form-control" name="trn_ship_edit" v-model="uuss_edit.trn"></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Descripcion</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><textarea type="text" class="form-control" name="description_ship_edit" v-model="uuss_edit.description"> </textarea> </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-info col-12 col-md-2 offset-md-4" @click="mUpdateUUSS"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3" >
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register" v-if="cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>
                            <input type="text" class="form-control-plaintext" v-else :value="cDtsUser.name_port">
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchUUSS(1)">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="list_uuss_edit.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Codigo / Nombre</th>
                                        <th>Tipo</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lu, index) in list_uuss_edit" :key="lu.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span v-if="lu.name.length > 0">{{ lu.name }}</span>
                                            <span v-else>SIN REGISTRO</span> 
                                            / 
                                            <span v-if="lu.code.length > 0">{{ lu.code }}</span>
                                            <span v-else>SIN REGISTRO</span> 
                                        </td>
                                        <td>{{ lu.description_navy }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectShipEdit(lu)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
                    
                </div>
                <!-- end second (edit) tab -->

                <div class="tab-pane fade"  id="nav-low" role="tabpanel" aria-labelledby="nav-home-tab" >
                    
                    <h6>BAJA UUSS</h6>
                    <hr>
                    <transition name="fade" mode="out-in">

                    <div v-if="uuss_low.id > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{ uuss_low.captain }}</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseLow">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Nombre</b></td>
                                    <td><b>Tipo</b></td>
                                    <td><b>Operabilidad</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control-plaintext" name="name_ship_edit" v-model="uuss_low.name"></td>
                                    <td>
                                        <select name="type_uuss" class="form-control" id="type_uuss" v-model="uuss_low.type_uuss" disabled>
                                            <option v-for="usup in uuss" :value="usup.id" :key="usup.id" :selected="usup.id === uuss_low.type_uuss ? true : false">{{usup.detail}}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select name="operability_uuss" class="form-control" id="operability_uuss" v-model="uuss_low.operability" disabled>
                                            <option v-for="oper in operabilitys" :value="oper.id" :key="oper.id" :selected="oper.id === uuss_low.operability ? true : false">{{oper.detail}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Codigo</b></td>
                                    <td><b>TRB</b></td> 
                                    <td><b>TRN</b></td>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control-plaintext" name="code_ship_edit" v-model="uuss_low.code"></td>
                                    <td><input type="numeric" class="form-control-plaintext" name="trb_ship_edit" v-model="uuss_low.trb"></td> 
                                    <td><input type="text" class="form-control-plaintext" name="trn_ship_edit" v-model="uuss_low.trn"></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Descripcion</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><textarea type="text" class="form-control-plaintext" name="description_ship_edit" v-model="uuss_low.description"> </textarea> </td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Detalle Baja</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><textarea type="text" class="form-control" name="description_ship_low" v-model="uuss_low.description_low"> </textarea> </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-danger col-12 col-md-2 offset-md-4" @click="mLowUUSS"><font-awesome-icon icon="arrow-circle-down" size="2x" /></button>
                        <button class="btn btn-warning col-12 col-md-2" @click="mCloseLow"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
                            <!-- listar las capitanias -->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" v-model="captain_register" v-if="cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'">
                                <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>
                            <input type="text" class="form-control-plaintext" v-else :value="cDtsUser.name_port">
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchUUSS(2)">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="list_uuss_low.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Codigo / Nombre</th>
                                        <th>Tipo</th>
                                        <th><font-awesome-icon icon="times-circle" size="2x"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lul, index) in list_uuss_low" :key="lul.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span v-if="lul.name.length > 0">{{ lul.name }}</span>
                                            <span v-else>SIN REGISTRO</span> 
                                            / 
                                            <span v-if="lul.code.length > 0">{{ lul.code }}</span>
                                            <span v-else>SIN REGISTRO</span>
                                        </td>
                                        <td>{{ lul.description_navy }}</td>
                                        <td>
                                            <button class="btn btn-outline-danger" @click="mSelectShipLow(lul)">
                                                <font-awesome-icon icon="times-circle"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>   
                </div>
                <!-- end tirdth tab (low) -->

            </div>

        </div>
        <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'UUSS',
    data(){
        return{
            list_uuss_edit:[],
            list_uuss_low:[],
            uuss_edit:{
                id:0,
                captain:null,
                name:null,
                type_uuss:0,
                code:null,
                trb:0,
                trn:0,
                operability:0,
                description:null,
                description_navy:null
            },
            uuss_low:{
                id:0,
                captain:null,
                name:null,
                type_uuss:0,
                code:null,
                trb:0,
                trn:0,
                operability:0,
                description:null,
                description_navy:null,
                description_low:null
            },
            id_modal_progress:'load_uuss',
            title_modal:'Registrando',
            send_dispatch:true,
            ports:[],
            uuss:[],
            operabilitys:[],
            captain_register:{
                id:0,
                name_port:null
            },
            uuss_new:{
                id_captain:0,
                name:null,
                operability:0,
                type_uuss:0,
                code:null,
                trb:0,
                trn:0,
                description:null
            }
        }
    },
    mounted(){
        this.mInit();
    },
    methods:{
        mCloseEdit(){
            this.uuss_edit.id=0;
            this.uuss_edit.captain=null;
            this.uuss_edit.name=null;
            this.uuss_edit.type_uuss=0;
            this.uuss_edit.code=null;
            this.uuss_edit.trb=0;
            this.uuss_edit.trn=0;
            this.uuss_edit.description=null;
            this.uuss_edit.description_navy=null;
        },
        mCloseLow(){
            this.uuss_low.id=0;
            this.uuss_low.captain=null;
            this.uuss_low.name=null;
            this.uuss_low.type_uuss=0;
            this.uuss_low.code=null;
            this.uuss_low.trb=0;
            this.uuss_low.trn=0;
            this.uuss_low.description=null;
            this.uuss_low.description_navy=null;
        },
        mSelectShipEdit(na){
            // console.log('la nave ha sido seleccionada');
            // console.log(na);
            this.uuss_edit.id=na.id;
            this.uuss_edit.name=na.name;
            this.uuss_edit.type_uuss=na.type_uuss;
            this.uuss_edit.trb=na.trb;
            this.uuss_edit.trn=na.trn;
            this.uuss_edit.code=na.code;
            this.uuss_edit.description_navy=na.description_navy;
            this.uuss_edit.description=na.description;
            this.uuss_edit.operability=na.operability;
            this.uuss_edit.captain=na.captain;
        },
        mSelectShipLow(na){
            // console.log('la nave ha sido seleccionada');
            // console.log(na);
            this.uuss_low.id=na.id;
            this.uuss_low.name=na.name;
            this.uuss_low.type_uuss=na.type_uuss;
            this.uuss_low.trb=na.trb;
            this.uuss_low.trn=na.trn;
            this.uuss_low.code=na.code;
            this.uuss_low.description_navy=na.description_navy;
            this.uuss_low.description=na.description;
            this.uuss_low.operability=na.operability;
            this.uuss_low.captain=na.captain;
        },
        async mSearchUUSS(tv = 1){
            if(this.cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'){
                if(this.captain_register.id===0){
                toastr.warning('Seleccione una Capitania', 'Capitania');
                return false;
            }
            }else{
                this.captain_register.id=this.cDtsUser.portId;
                this.captain_register.name_port=this.cDtsUser.name_port;
            }

            this.list_uuss_edit=[];
            this.list_uuss_low=[];
            let list_uuss = await axios.get(`getListUS/${this.captain_register.id}?api_token=${Vue.auth.getToken()}`);
            // console.log(list_uuss);
            try {
                console.log(tv);
                if(list_uuss.data.length>0){
                    if(tv===1){
                        this.list_uuss_edit=list_uuss.data;
                    }else{
                        this.list_uuss_low=list_uuss.data;
                    }
                }else{
                    toastr.info(`La capitania ${this.captain_register.name_port} no registra UUSS`, 'Mensaje');
                }                 
            } catch (error) {
                console.log(error);
                toastr.error(`Ha ocurrido un error al Recuperar los datos`, 'Error UUSS-02');
            }               
        },
        async mInit(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            let us=await axios.get(`globals/ships?api_token=${Vue.auth.getToken()}`);
            let states=await axios.get(`globals/operability?api_token=${Vue.auth.getToken()}`);
            this.uuss=us.data;
            this.ports=cp.data;
            this.operabilitys=states.data;
        },
        async mRegisterInitUUSS(){
            // validamos y registramos la capitania
            if(this.mValidateRegister()){
                let message = {
                    title: 'Registro de UUSS',
                    body: `¿Desea Registrar la Unidad de Superficie para la capitania ${this.captain_register.name_port}?`
                }
                this.uuss_new.id_captain=this.captain_register.id;
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            console.log(`estamos enviando al servidor`);
                            let reg_uuss=await axios.post(`uussInsert?api_token=${Vue.auth.getToken()}`, qs.stringify(this.uuss_new));
                            console.log(reg_uuss);
                            setTimeout(()=>{                                
                                if(reg_uuss.data.status){
                                    toastr.success(reg_uuss.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.uuss_new.id_captain=0;
                                    this.uuss_new.name=null;
                                    this.uuss_new.operability=0;
                                    this.uuss_new.type_uuss=0;
                                    this.uuss_new.code=0;
                                    this.uuss_new.trb=0;
                                    this.uuss_new.trn=0;
                                    this.uuss_new.description=null;
                                }else{
                                    toastr.success(reg_uuss.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el registro', 'Error UUSS-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateRegister(){
            if(this.cDtsUser.roleAssign !== 'OPERADOR CAPITANIA'){
                if(this.captain_register.id===0){
                toastr.warning('Seleccione una Capitania', 'Capitania');
                return false;
            }
            }else{
                this.captain_register.id=this.cDtsUser.portId;
                this.captain_register.name_port=this.cDtsUser.name_port;
            }
            // if(this.uuss_new.name===null || this.uuss_new.name===''){
            //     toastr.warning('Indique el nombre de la nave', 'Atencion');
            //     return false;
            // }
            if(this.uuss_new.type_uuss===0){
                toastr.warning('Seleccione un tipo de nave', 'Tipo Nave');
                return false;
            }
            if(this.uuss_new.operability===0){
                toastr.warning('Seleccione un estado operativo de la nave', 'Tipo Nave');
                return false;
            }
            // if(this.uuss_new.trb===0 || this.uuss_new.trb<0){
            //     toastr.warning('Indique un valor correcto', 'TRB');
            //     return false;
            // }
            // if(this.uuss_new.trn===0 || this.uuss_new.trn<0){
            //     toastr.warning('Indique un valor correcto', 'TRN');
            //     return false;
            // }
            if(this.uuss_new.description===null || this.uuss_new.description === '' ){
                toastr.warning('Indique una breve descripcion de la nave', 'Atencion');
                return false;
            }
            return true;
        },
        async mUpdateUUSS(){
            // validamos y registramos la capitania
            if(this.mValidateUpdate()){
                let message = {
                    title: 'Actualizacion UUSS',
                    body: `¿Desea Actualizar la Unidad de Superficie para la capitania ${this.uuss_edit.captain}?`
                }
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            
                            let update_uuss=await axios.post(`uussUpdate?api_token=${Vue.auth.getToken()}`, qs.stringify(this.uuss_edit));
                            
                            this.mSearchUUSS(1);

                            setTimeout(()=>{                                
                                if(update_uuss.data.status){
                                    toastr.success(update_uuss.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.mCloseEdit();
                                }else{
                                    toastr.success(update_uuss.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en la actualizacion', 'Error UUSS-02')
                                
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateUpdate(){
            if(this.uuss_edit.type_uuss===0){
                toastr.warning('Seleccione un tipo de nave', 'Tipo Nave');
                return false;
            }
            if(this.uuss_edit.operability===0){
                toastr.warning('Seleccione un estado de operabilidad de la nave', 'Tipo Nave');
                return false;
            }
            if(this.uuss_edit.trb<0){
                toastr.warning('Indique un valor correcto', 'TRB');
                return false;
            }
            if(this.uuss_edit.trn<0){
                toastr.warning('Indique un valor correcto', 'TRN');
                return false;
            }
            if(this.uuss_edit.description===null || this.uuss_edit.description === '' ){
                toastr.warning('Indique una breve descripcion de la nave', 'Atencion');
                return false;
            }
            return true;
        },
        async mLowUUSS(){
            // validamos y registramos la capitania
            if(this.mValidateLow()){
                let message = {
                    title: 'Baja UUSS',
                    body: `¿Desea dar de Baja la Unidad de Superficie para la capitania ${this.uuss_low.captain}?`
                }
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {                            
                            // this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            
                            let low_uuss=await axios.post(`uussLow?api_token=${Vue.auth.getToken()}`, qs.stringify(this.uuss_low));
                            
                            this.mSearchUUSS(2);
                            this.mSearchUUSS(1);

                            setTimeout(()=>{                                
                                if(low_uuss.data.status){
                                    toastr.success(low_uuss.data.response, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    this.mCloseLow();
                                }else{
                                    toastr.success(low_uuss.data.response, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en la actualizacion', 'Error UUSS-02')
                                
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
        },
        mValidateLow(){
            if(this.uuss_low.description_low===null || this.uuss_low.description_low === '' ){
                toastr.warning('Indique una breve descripcion de las causales de la baja', 'Atencion');
                return false;
            }
            return true;
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        } 
    },
    components:{
        'modal-loading':modalLoading
    }    
}
</script>

<style>
.required-text{
    color:red; 
    font-weight:bold;
}
</style>


// WEBPACK FOOTER //
// src/components/uuss/uuss.vue